import React from 'react';
import { PriceField2 } from 'components/UI';
import { FieldError } from '@spike/model';
import { GenericOrderItem } from 'components/Payments/SingleSale/SingleSale';
import { OrderizableTypes } from '@spike/order-model';

type ItemPrice = {
    item: GenericOrderItem;
    className?: string;
    inputClassName?: string;
    errors?: FieldError[];
    onChange: (subtotal?: number) => void;
};

export const SingleSaleTableItemPrice: React.FC<ItemPrice> = props => {
    return (
        <span className={props.className}>
            {props.item.orderItem.orderizable.type !== OrderizableTypes.CUSTOM && `$${props.item.orderItem.amount}`}

            {props.item.orderItem.orderizable.type === OrderizableTypes.CUSTOM && (
                <PriceField2
                    scale={2}
                    precision={6}
                    errors={props.errors}
                    className={props.inputClassName}
                    name={`${props.item.orderItem.uuid}_price`}
                    value={Number(props.item.orderItem.amount)}
                    onChange={props.onChange}
                />
            )}
        </span>
    );
};
